module.exports = __webpack_public_path__ + "static/media/400092_02.cb44807d.png";